export const LOCAL_STORAGE_TOKEN_KEY = 'pc_authToken'
// this is the name used by redux-localstorage-simple for the local redux store.
export const LOCAL_STORAGE_SIGNAL_DATA = 'signal-local_local'

export const REFRESH_WINDOW = 1000 * 60 * 15 // Refresh 15 min before token expires
export const CMD_CREATE_SESSION = 'createAuthSession'
export const CMD_DESTROY_SESSION = 'destroyAuthSession'

export const AUTH_POLICY = 'B2C_1_Meridian'

/**
 * Action Types
 */
export const AUTH_REQUEST = 'AUTH/REQUEST'
export const AUTH_SUCCESS = 'AUTH/SUCCESSFUL'
export const AUTH_FAILURE = 'AUTH/FAILURE'
export const AUTH_LOGOUT = 'AUTH/LOGOUT'
export const NOTIFY_ACCOUNT_CHANGE = 'AUTH/NOTIFY_ACCOUNT_CHANGE'

export const PC_AUTH_COOKIE = 'pc-auth'
export const PC_AUTH_COOKIE_QA = 'pc-auth-qa'
